import React, { useCallback, useContext } from 'react'
import SectionFormContainer from '../../components/SectionFormContainer'
import GroomingProfileWizardContext from './GroomingProfileWizardContext'
import { TextField } from '@material-ui/core'

const CurrentWeight = (props) => {
	const {
		wizardContextProvider: { wizard_state, setWizardAttributeAndValues }
	} = useContext(GroomingProfileWizardContext)
	const { attr, title = '', subtext = '' } = props

	const handleTextEntry = useCallback(
		(e) => {
			const value = e.target.value
			const newValues = { ...wizard_state }
			newValues[attr] = value
			setWizardAttributeAndValues(newValues)
		},
		[wizard_state, setWizardAttributeAndValues, attr]
	)

	return (
		<SectionFormContainer
			title={title}
			titleStyles={{ flex: 0, marginBottom: '1rem' }}
			childrenContainerStyles={{ flex: 0, marginBottom: '5rem' }}
			subtext={subtext}>
			<TextField
				variant="filled"
				label="Current weight in lbs"
				value={wizard_state[attr]}
				onChange={handleTextEntry}
			/>
		</SectionFormContainer>
	)
}

export default CurrentWeight
